import client from './client';

const notifications = {
  getAll:      ()    => client.get('/notifications/'),
  markRead:    (id)  => client.post(`/notifications/${id}/read/`),
  markAllRead: ()    => client.post('/notifications/read-all/'),
};

export default notifications;
